export default {"src":"/_next/static/media/chat-alt.ec8d814b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};